import React from "react";
import { faCaretSquareDown } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dropdown, Menu } from "antd";
import styled, { CSSProperties } from "styled-components";
import Button from "../Button";
import StarCounter from "../StarCounter";
import { faCheckCircle } from "@fortawesome/free-regular-svg-icons";
import inProgImg from "../../assets/InProgress.png";

const BannerWrapper = styled.div`
  width: 100%;
  border: 2px solid #efefef;
  border-radius: 6px;
  display: flex;
  justify-content: space-between;
  padding: 16px 32px;
  h2,
  h4 {
    margin: 0;
  }
  .actions {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    button {
      margin-left: 32px;
    }
  }
`;

type BannerProps = {
  buttonText?: string;
  onClick?: () => void;
  title: string;
  subtitle: string;
  stars?: number;
  checked?: boolean;
  inProgress?: boolean;
  style?: CSSProperties;
  menu?: { text: string; onClick: () => void }[];
};

const Banner = ({
  buttonText,
  onClick,
  stars,
  title,
  subtitle,
  checked,
  inProgress,
  style,
  menu,
}: BannerProps) => {
  return (
    <BannerWrapper className="banner" style={style}>
      <div>
        <h2>{title}</h2>
        <h4>{subtitle}</h4>
      </div>
      <div className="actions">
        {checked && (
          <FontAwesomeIcon
            icon={faCheckCircle}
            size="2x"
            style={{ marginRight: 16, color: "green" }}
          />
        )}
        {inProgress && (
          <img
            src={inProgImg}
            alt="In progress"
            style={{ width: 76, marginRight: 16 }}
          />
        )}
        {stars && <StarCounter stars={stars} />}
        {onClick && (
          <Button onClick={onClick}>{buttonText || "Continue"}</Button>
        )}
        {menu && (
          <Dropdown
            overlay={
              <Menu>
                {menu.map((m) => (
                  <Menu.Item onClick={m.onClick}>{m.text}</Menu.Item>
                ))}
              </Menu>
            }
          >
            <FontAwesomeIcon
              icon={faCaretSquareDown}
              size="2x"
              style={{ marginLeft: 16, opacity: 0.7 }}
            />
          </Dropdown>
        )}
      </div>
    </BannerWrapper>
  );
};

export default Banner;
